import { ChatChannelInstance } from "../types"
import { ChannelMemberResponse } from 'stream-chat'
import { isChatGroup, isMemberModerator } from "../utils"

export type UseMyMembershipProps = {
  channel?: ChatChannelInstance
  myMember?: ChannelMemberResponse
}

export function useMyMembership({ channel, myMember }: UseMyMembershipProps) {
  const isGroup = isChatGroup(channel)
  const groupOwner = isGroup ? channel?.data?.created_by : null
  const isOwner = groupOwner?.id === myMember?.user?.id

  const isGroupOwner = isGroup && isOwner
  const isModerator = isMemberModerator(myMember)
  const isAdmin = isGroupOwner || isModerator

  return {
    isAdmin,
    isGroupOwner,
    myMember,
    isGroup,
    groupOwner,
  }
}